app.config( function($translateProvider) {
    $translateProvider.translations('en-gb', {
        // Legacy METER_SUPPLIER keys remain unchanged in code; UI copy now uses Utility Provider terminology.
        METER_SUPPLIER_INFORMATION: 'Utility Provider Information',

        ADD_NEW_METER_SUPPLIER: 'Add a new Utility Provider',
        EDIT_METER_SUPPLIER: 'Edit Utility Provider',

        METER_SUPPLIER_LIST: 'Utility Providers',
        METER_SUPPLIER_ADD: 'Add a new Utility Provider',
        METER_SUPPLIER_EDIT: 'Edit Utility Provider',

        METER_SUPPLIER_CREATED: 'Utility Provider created successfully',
        METER_SUPPLIER_UPDATED: 'Utility Provider updated successfully',
        METER_SUPPLIER_DELETED: 'Utility Provider deleted successfully',
    });
});
